import { Button, Col, DatePicker, Form, message, Row, Select, Spin } from 'antd';
import debounce from "lodash/debounce";
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { auditService } from '../_services/audit.service';
import { dashboardService } from '../_services/dashboard.service';
import AuditedReports from './components/AuditedReports';
import ComparativeChart from './components/ComparativeChart';
import CountByExamReport from './components/CountByExamReport';
import RankingAudited from './components/RankingAudited';
import { errors } from '../_constants/errors';
const cookies = new Cookies();

const HomePage = () => {
  const history = useHistory();
  const [form] = Form.useForm();
  const [branchOffices, setBranchOffices] = useState();
  const [admins, setAdmins] = useState([]);
  const [paramedics, setParamedics] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [batteries, setBatteries] = useState([]);
  const [existingSession, setExistingSession] = useState();
  const [loading, setLoading] = useState({
    audit: false,
    companies: false,
    admins: false,
    branchOffices: false,
    batteries: false,
    paramedics: false,
  });
  const [loadingExistingSession, setLoadingExistingSession] = useState(false);

  const fetchBranchOffices = async () => {
    try {
      setLoading((_loading) => ({ ..._loading, branchOffices: true }));
      const response = await dashboardService.getBranchOffices({});
      setBranchOffices(response.data);
    } catch (error) {
      console.error(error);
      message.error({
        content: 'Ocurrió un error al obtener las sucursales',
        style: {
          marginTop: '45vh',
        },
      });
    } finally {
      setLoading((_loading) => ({ ..._loading, branchOffices: false }));
    }
  }

  const fetchAdmins = async (params) => {
    try {
      setLoading((_loading) => ({ ..._loading, admins: true }));
      const response = await auditService.getAdmins(params || null);
      setAdmins(response);
    } catch (error) {
      console.error(error);
      message.error({
        content: 'Ocurrió un error al obtener los doctores',
        style: {
          marginTop: '45vh',
        },
      });
    } finally {
      setLoading((_loading) => ({ ..._loading, admins: false }));
    }
  }

  const fetchParamedics = async (params) => {
    try {
      setLoading((_loading) => ({ ..._loading, paramedics: true }));
      const response = await auditService.getAdmins({...params, paramedics: true});
      setParamedics(response);
    } catch (error) {
      console.error(error);
      message.error({
        content: 'Ocurrió un error al obtener los paramédicos',
        style: {
          marginTop: '45vh',
        },
      });
    } finally {
      setLoading((_loading) => ({ ..._loading, paramedics: false }));
    }
  }

  const fetchCompanies = async (params) => {
    try {
      setLoading((_loading) => ({ ..._loading, companies: true }));
      const response = await auditService.getCompanies(params || null);
      if (response?.length > 0) {
        setCompanies(response);
      } else {
        message.error({
          content: 'No se encontraron atenciones para la empresa seleccionada',
          style: {
            marginTop: '45vh',
          },
        });
      }
    } catch (error) {
      console.error(error);
      message.error({
        content: 'Ocurrió un error al obtener las compañias',
        style: {
          marginTop: '45vh',
        },
      });
    } finally {
      setLoading((_loading) => ({ ..._loading, companies: false }));
    }
  }

  const fetchBatteries = async (params) => {
    try {
      setLoading((_loading) => ({ ..._loading, batteries: true }));
      const response = await auditService.getBatteries(params || null);
      setBatteries(response);
    } catch (error) {
      console.error(error);
      message.error({
        content: 'Ocurrió un error al obtener las baterías',
        style: {
          marginTop: '45vh',
        },
      });
    } finally {
      setLoading((_loading) => ({ ..._loading, batteries: false }));
    }
  }

  const fetchExistingOpenSession = async () => {
    setLoadingExistingSession(true);
    try {
      const response = await dashboardService.getExistingOpenSession({});

      if (response.data && response.data.length) {
        setExistingSession(response.data[0]);
      }
    } catch (error) {
      message.error({
        content: 'Ocurrió un error al obtener las sesiones',
        style: {
          marginTop: '45vh',
        },
      });
    } finally {
      setLoadingExistingSession(false);
    }
  }

  useEffect(() => {
    fetchExistingOpenSession();
    fetchBranchOffices();
    fetchAdmins();
    fetchParamedics();
    fetchCompanies();
    fetchBatteries();
  }, [])

  const createAudit = async () => {
    try {
      setLoading((_loading) => ({ ..._loading, audit: true }));
      const formValues = form.getFieldsValue();
      const params = {
        ...(existingSession && { auditSessionId: existingSession.audit_session_id }),
        ...(formValues?.admin?.length > 0 && { admin_id: formValues.admin }),
        ...(formValues?.battery?.length > 0 && { battery_id: formValues.battery }),
        ...(formValues?.branch_office?.length > 0 && { branch_office_id: formValues.branch_office }),
        ...(formValues?.company?.length > 0 && { company_id: formValues.company }),
        ...(formValues?.dateRange?.[0] && { startDate: formValues.dateRange[0].format('YYYY-MM-DD') }),
        ...(formValues?.dateRange?.[1] && { endDate: formValues.dateRange[1].format('YYYY-MM-DD') }),
        ...(formValues?.paramedic?.length > 0 && { save_admin_id: formValues.paramedic }),
      };
      const response = await auditService.create(params);
      delete params.auditSessionId;
      if (response?.id) {
        history.push(`/auditoria/${response.department_id}/${response.audit_session_id}/${response.id}?${new URLSearchParams(params).toString()}`);
      }
    } catch (error) {
      console.error(error);
      if (errors[error]) {
        message.error({
          content: errors[error],
          style: {
            marginTop: '45vh',
          },
        });
      } else {
        message.error({
          content: 'Ha ocurrido un error al iniciar el proceso de auditoria',
          style: {
            marginTop: '45vh',
          },
        });
      }
    } finally {
      setLoading((_loading) => ({ ..._loading, audit: false }));
    }
  }

  const isManager = () => {
    const roles = cookies.get('roles');
    return roles.includes('gerencia') && roles.includes('super_usuario');
  }

  if (loadingExistingSession) {
    return (
      <Spin />
    )
  }

  const searchAdmins = debounce(async (value) => {
    await fetchAdmins({ query: value });
  }, 500);

  const searchParamedics = debounce(async (value) => {
    await fetchParamedics({ query: value });
  }, 500);

  const searchCompanies = debounce(async (value) => {
    await fetchCompanies({ query: value });
  }, 500);

  const searchBatteries = debounce(async (value) => {
    await fetchBatteries({ query: value });
  }, 500);

  return (
    <React.Fragment>
      <Form layout="vertical" size="large" form={form}>
        <Row justify="space-between">
          <Col xs={24} lg={24}>
            <Row gutter={8}>
              <Col xs={24} lg={6}>
                <Spin className="cmt-spin" spinning={loading.companies}>
                  <Form.Item
                    name='company'
                    label="Empresa">
                    <Select
                      showSearch
                      filterOption={false}
                      allowClear
                      showArrow
                      mode="multiple"
                      className='cmt-select'
                      onSearch={searchCompanies}
                      onClear={() => fetchCompanies()}
                    >
                      {companies?.map(company =>
                        <Select.Option
                          key={`${company.id}${company.business_name}`}
                          value={company.id}
                        >
                          {company.business_name}
                        </Select.Option>
                      )}
                    </Select>
                  </Form.Item>
                </Spin>
              </Col>
              <Col xs={24} lg={6}>
                <Spin className="cmt-spin" spinning={loading.admins}>
                  <Form.Item
                    name='admin'
                    label="Medico">
                    <Select
                      showSearch
                      filterOption={false}
                      allowClear
                      showArrow
                      mode="multiple"
                      className='cmt-select'
                      onSearch={searchAdmins}
                      onClear={() => fetchAdmins()}
                    >
                      {admins?.map(admin =>
                        <Select.Option
                          key={`${admin.id}${admin.full_name}`}
                          value={admin.id}
                        >
                          {admin.full_name}
                        </Select.Option>
                      )}
                    </Select>
                  </Form.Item>
                </Spin>
              </Col>
              <Col xs={24} lg={6}>
                <Spin className="cmt-spin" spinning={loading.branchOffices}>
                  <Form.Item
                    name='branch_office'
                    label="Sucursal">
                    <Select
                      showSearch
                      allowClear
                      showArrow
                      mode="multiple"
                      className='cmt-select'
                      options={branchOffices?.map(branchOffice => ({ label: branchOffice.name, value: branchOffice.id }))}
                      filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                    >
                      {branchOffices?.map(branchOffice =>
                        <Select.Option
                          key={branchOffice.id}
                          value={branchOffice.id}
                        >
                          {branchOffice.name}
                        </Select.Option>
                      )}
                    </Select>
                  </Form.Item>
                </Spin>
              </Col>
              <Col xs={24} lg={6}>
                <Spin className="cmt-spin" spinning={loading.batteries}>
                  <Form.Item
                    name='battery'
                    label="Batería">
                    <Select
                      showSearch
                      filterOption={false}
                      allowClear
                      showArrow
                      mode="multiple"
                      className='cmt-select'
                      onSearch={searchBatteries}
                      onClear={() => fetchBatteries()}
                    >
                      {batteries?.map(battery =>
                        <Select.Option
                          key={`${battery.id}${battery.name}`}
                          value={battery.id}
                        >
                          {battery.name}
                        </Select.Option>
                      )}
                    </Select>
                  </Form.Item>
                </Spin>
              </Col>
              <Col xs={24} lg={6}>
                <Form.Item
                  name='dateRange'
                  label="Rango de fecha">
                  <DatePicker.RangePicker
                    className='cmt-select'
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} lg={6}>
                <Spin className="cmt-spin" spinning={loading.paramedics}>
                  <Form.Item
                    name='paramedic'
                    label="Equipo Paramédico">
                    <Select
                      showSearch
                      filterOption={false}
                      allowClear
                      showArrow
                      mode="multiple"
                      className='cmt-select'
                      onSearch={searchParamedics}
                      onClear={() => fetchParamedics()}
                    >
                      {paramedics?.map(paramedic =>
                        <Select.Option
                          key={`${paramedic.id}${paramedic.full_name}`}
                          value={paramedic.id}
                        >
                          {paramedic.full_name}
                        </Select.Option>
                      )}
                    </Select>
                  </Form.Item>
                </Spin>
              </Col>
            </Row>
          </Col>
          <Col>
            <Form.Item>
              {
                existingSession ? <Button loading={loading.audit} type="primary" size="large" onClick={createAudit}>Continuar Auditoria</Button> :
                  <Button loading={loading.audit} type="primary" size="large" onClick={createAudit}>Comenzar Auditoria</Button>
              }
            </Form.Item>
          </Col>
        </Row>
      </Form >
      <Row gutter={10}>
        <Col xs={24} lg={12}>
          {branchOffices && <AuditedReports branchOffices={branchOffices} />}
        </Col>
        <Col xs={24} lg={12}>
          <CountByExamReport />
        </Col>
        <Col xs={24} lg={24}>
          <ComparativeChart />
        </Col>
        <Col xs={24} lg={12}>
          {isManager() && <RankingAudited />}
        </Col>
      </Row>
    </React.Fragment >
  );
}

export { HomePage };
